import { fromJson } from '@bufbuild/protobuf';
import type { InnerThoughtsEntity } from '@platform/timeline';
import {
  InnerThoughtsCompletedSchema,
  InnerThoughtsStartedSchema,
  InnerThoughtsUpdateSchema,
} from '../pb/proto/sem/middleware/inner_thoughts_pb';
import { registerSem } from '../registry';

registerSem('inner.thoughts.started', ({ ev, now, convId }) => {
  const pb = fromJson(InnerThoughtsStartedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'add',
    convId,
    entity: {
      id: entityId,
      kind: 'inner_thoughts',
      timestamp: now,
      props: {
        status: 'active',
        text: pb.data?.text ?? undefined,
      },
    } as InnerThoughtsEntity,
  };
});

registerSem('inner.thoughts.update', ({ ev, now, convId }) => {
  const pb = fromJson(InnerThoughtsUpdateSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'inner_thoughts',
      timestamp: now,
      props: {
        status: 'active',
        text: pb.data?.text ?? undefined,
      },
    } as InnerThoughtsEntity,
  };
});

registerSem('inner.thoughts.completed', ({ ev, now, convId }) => {
  const pb = fromJson(InnerThoughtsCompletedSchema, (ev.data || {}) as any);
  const entityId = pb.itemId;
  if (!entityId) return null;
  return {
    kind: 'upsert',
    convId,
    entity: {
      id: entityId,
      kind: 'inner_thoughts',
      timestamp: now,
      props: {
        status: pb.success === false ? 'error' : 'completed',
        text: pb.data?.text ?? undefined,
        success: pb.success ?? undefined,
        error: pb.error ?? undefined,
      },
    } as InnerThoughtsEntity,
  };
});
